import { Container } from "./styles"
import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import Voucher from '../../components/Voucher'
import Logo from '../../assets/logo.png'
import Button from '../../components/Button'

// const logo = 
const voucher = {
  logo: Logo, 
  nome_hotel: 'Hotelzinho',
  endereco_hotel: 'endereço',
  mapa_hotel: 'https://goo.gl/maps/PuSNKUs9sdHGCspL8',
  numero_reserva: '00001',
  nome_hospede: 'Lineu Silva',
  numero_adulto: 2,
  numero_crianca: 1,
  data_de_chegada: '21/10/2021',
  data_de_partida: '23/10/2021',
  tipo_de_quarto: 'padrão',
  data_da_reserva: '21/09/2021',
  observacoes: 'proibido animais',
  informacoes_gerais: 'Café da Manhã incluso na diária.',
  telefone: '9 9999-9999',
  email: 'email@email.com',
}

const TestVoucher = () => {
    return (
        <Container>
          <PDFViewer width='500px' height='400px'>
            <Voucher 
              logo = {voucher.logo} 
              nome_hotel = {voucher.nome_hotel} 
              endereco_hotel = {voucher.endereco_hotel} 
              mapa_hotel = {voucher.mapa_hotel} 
              numero_reserva = {voucher.numero_reserva} 
              nome_hospede = {voucher.nome_hospede} 
              numero_adulto = {voucher.numero_adulto} 
              numero_crianca = {voucher.numero_crianca} 
              data_de_chegada = {voucher.data_de_chegada} 
              data_de_partida = {voucher.data_de_partida} 
              tipo_de_quarto = {voucher.tipo_de_quarto} 
              data_da_reserva = {voucher.data_da_reserva} 
              observacoes = {voucher.observacoes} 
              informacoes_gerais = {voucher.informacoes_gerais} 
              telefone = {voucher.telefone} 
              email = {voucher.email} 
            />
          </PDFViewer>
          <Button format='home'>
          <PDFDownloadLink style={{color: 'white'}}document={<Voucher 
            logo = {voucher.logo} 
            nome_hotel = {voucher.nome_hotel} 
            endereco_hotel = {voucher.endereco_hotel} 
            mapa_hotel = {voucher.mapa_hotel} 
            numero_reserva = {voucher.numero_reserva} 
            nome_hospede = {voucher.nome_hospede} 
            numero_adulto = {voucher.numero_adulto} 
            numero_crianca = {voucher.numero_crianca} 
            data_de_chegada = {voucher.data_de_chegada} 
            data_de_partida = {voucher.data_de_partida} 
            tipo_de_quarto = {voucher.tipo_de_quarto} 
            data_da_reserva = {voucher.data_da_reserva} 
            observacoes = {voucher.observacoes} 
            informacoes_gerais = {voucher.informacoes_gerais} 
            telefone = {voucher.telefone} 
            email = {voucher.email} 
          />} fileName="voucher.pdf">
            {({ blob, url, loading, error }) =>
              loading ? 'Carregando documento...' : 'Baixar PDF!'
            }
          </PDFDownloadLink>
          </Button>
        </Container>
    )
}

export default TestVoucher
